import prepareAssertions from '~/packages/variable/prepareAssertions.util'
import { Variable } from '~/packages/variable/variables.typing'
import { defineAction, number, object, string } from '~/prix'
import eadPortfolioEnrollmentStatsAction from './eadPortfolioEnrollmentStats.action.json' assert { type: 'json' }
import { childrenType, spaceForPoint } from '~/prix/types/presets/space'
import { timeForIncidence } from '~/prix/types/presets/time'
import { select } from '~/prix/types/presets/select'
import { variable } from '~/prix/types/presets/variable'
import { assertions } from '~/prix/types/presets/assertions'
import { analysis } from '~/prix/types/presets/analysis'
import prefixProperties from '~/prix/utils/prefixProperties'
import enrollmentEad from '~/packages/legalEntityGeoprocessing/map/ead/enrollment.entity'
import expression from '~/prix/types/expression'
import studentEad from '~/packages/legalEntityGeoprocessing/map/ead/student.entity'
import getRecommendedCacheOptions from '~/utils/server/stats/getRecommendedCacheOptions'
import { eadEnrollmentVariable } from '../enrollmentStats/eadEnrollmentStats.definition'

const combinedShape = object({
  ...prefixProperties('matricula.', enrollmentEad.schema.shape),
  ...prefixProperties('aluno.', studentEad.schema.shape),
})

const eadStatsExpression = expression(combinedShape.shape)

export const eadPortfolioEnrollmentVariable: Variable = {
  key: 'eadPortfolioEnrollment',
  categoryKey: 'eadEnrollment',
  categoryKeys: ['eadEnrollment'],
  actionDefinitionKey: eadPortfolioEnrollmentStatsAction.key,
  title: 'Todas as matrículas do portfólio',
  label: 'Geral',
  unitSingular: 'matrícula',
  unitPlural: 'matrículas',
  grammaticalGender: 'female',
  timeType: 'incidence',
  shape: combinedShape,
  betterDensity: 'more',
  relevance: 0.3,
  payload: {
    productName: 'Matrículas no EAD',
    portfolioName: ['Cursos Online'],
  },
  basicSelect: ['matricula.dataMatricula', 'aluno.nome'],
  detailedSelect: [],
  timeSeries: eadEnrollmentVariable.timeSeries,
  assertions: prepareAssertions(eadStatsExpression),
  compatibleChildrenTypes: ['country', 'macroRegion', 'state'],
}

const eadPortfolioEnrollmentStatsDefinition = defineAction({
  ...eadPortfolioEnrollmentStatsAction,
  input: object({
    variable,
    highlight: eadStatsExpression.isOptional(),
    filter: eadStatsExpression.isOptional(),
    space: spaceForPoint().isOptional(),
    time: timeForIncidence().isOptional(),
    select: select(combinedShape),
    assertions,
    analysis,
  }),
  output: object({
    items: object({
      value: number(),
      geoId: string().isOptional(),
      geoType: childrenType.isOptional(),
      dateTime: string().isOptional(),
    }),
  }),
  cache: getRecommendedCacheOptions,
})

export default eadPortfolioEnrollmentStatsDefinition
